import React from 'react';
import { Mail, MessageSquare, Headphones, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Support = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-gray-300 py-20 px-6 pt-24">
      <div className="max-w-3xl mx-auto">
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-[#4ade80] mb-8 hover:opacity-80 transition-opacity"
        >
          <ArrowLeft size={20} />
          Back
        </button>

        <div className="flex items-center gap-3 mb-6">
          <Headphones className="text-[#4ade80]" size={32} />
          <h1 className="text-3xl font-bold text-white">Support Center</h1>
        </div>

        <p className="mb-10 text-lg">Need help with an offer or have a question? Our US-based team is here to assist you.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-[#151515] p-6 rounded-2xl border border-gray-800 flex flex-col items-center text-center">
            <Mail className="text-[#4ade80] mb-4" size={40} />
            <h3 className="text-white font-bold mb-2">Email Support</h3>
            <p className="text-sm text-gray-400 mb-4">Typical response time: 24-48 hours</p>
            <a href="mailto:support@freebonusnow.com" className="bg-[#4ade80] text-black px-6 py-2 rounded-full font-bold hover:bg-[#3bbd6d] transition-colors">
              Contact Us
            </a>
          </div>

          <div className="bg-[#151515] p-6 rounded-2xl border border-gray-800 flex flex-col items-center text-center">
            <MessageSquare className="text-[#4ade80] mb-4" size={40} />
            <h3 className="text-white font-bold mb-2">Offer Status</h3>
            <p className="text-sm text-gray-400 mb-4">Please include your offer ID and screenshot of completion.</p>
            <span className="text-[#4ade80] font-mono text-sm">NYC Office Hours: 9 AM - 5 PM EST</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;